export default __webpack_public_path__ + "static/media/leadingPageSvg.78a66756.svg";